import React from 'react'
import ChartFlexSection from '@components/chart/ChartFlexSection'
import { IResponseOptAgencyAmountByType } from '@interfaces/api/IDashboard'
import TextChartTitle from '@components/text/TextChartTitle'
import Chart from 'react-google-charts'
import { PieChartOptions } from '@components/chart/setting'

const AgencyAmountByType = ({ title, data }: { title: string; data: IResponseOptAgencyAmountByType }) => {
  const options = PieChartOptions('มูลค่าโครงการ', 'ประเภทกิจกรรมบริการวิชาการ')

  const chartData = [
    ['ประเภทหน่วยงาน', 'จำนวนหน่วยงาน', { role: 'tooltip', type: 'string', p: { html: true } }],
    ...data.map((item) => {
      const row: (string | number)[] = []

      row.push(`${item.agency_type_name} (${item.total_agencies} หน่วยงาน)`)
      row.push(parseFloat(item.total_agencies))
      row.push(`<div style="padding:8px; width: 280px">
            <strong>${item.agency_type_name}</strong><br/>
            จำนวนหน่วยงาน : ${item.total_agencies} หน่วยงาน<br/>
          </div>
        `)

      return row
    }),
  ]

  return (
    <ChartFlexSection className="pagebreak">
      <TextChartTitle>{title}</TextChartTitle>
      <Chart width={'100%'} height={'500px'} chartType="PieChart" loader={<div>Loading Chart</div>} data={chartData} options={options} />
    </ChartFlexSection>
  )
}

export default AgencyAmountByType
